const TopProgressBar = () => {
  return (
    <div
      role="progressbar"
      aria-label="Refreshing"
      className="fixed top-0 left-0 right-0 h-[3px] z-[60] bg-side_bar_bg overflow-hidden"
    >
      <div
        className="h-full w-1/3 bg-bleu_text rounded-full"
        style={{ animation: "top-progress-bar 1.1s ease-in-out infinite" }}
      />
    </div>
  );
};

export default TopProgressBar;
